import { useSessionStorageValue } from "@react-hookz/web";

import type { UUID } from "../../../../../../../utils/uuid";

export function usePreviewStorage(): ReturnType<
  typeof useSessionStorageValue<Record<string, UUID>>
> {
  return useSessionStorageValue<Record<string, UUID>>("moment_preview_selected_recipients", {
    defaultValue: {},
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    parse: (str) => (str ? (JSON.parse(str) as Record<string, UUID>) : {}),
    stringify: JSON.stringify,
  });
}
